import { memo } from 'react';

import styles from './bounce-loader.module.css';

export const BounceLoader = memo(() => (
  <div className={styles.loader} />
));